import { cva } from 'class-variance-authority'

export const checkboxVariants = {
  input: cva([
    'relative',
    'outline-none',
    'focus:outline-none',
    'focus:ring-0',
    'focus:ring-offset-0',
    'focus-visible:border-2',
    'focus-visible:border-blurple-300',
    'appearance-none',
    'border',
    'border-border-default',
    'reading-dark:border-carbon-100',
    'hover:border-border-primary',
    'hover:border-2',
    'hover:cursor-pointer',
    'rounded',
    'h-5',
    'w-5',
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',
    'disabled:border',
    'disabled:hover:border-border-default',
    'disabled:focus:bg-blurple-300',
    'disabled:focus:border-blurple-300',
    'disabled:checked:bg-blurple-50',
    'disabled:checked:border-blurple-50',
    'disabled:checked:hover:bg-blurple-50',
    'disabled:checked:hover:border-blurple-50',
    'disabled:checked:focus:bg-blurple-50',
    'disabled:checked:focus:border-blurple-50',
    'checked:bg-blurple-300',
    'checked:border-blurple-300',
    'checked:hover:border-blurple-300',
    'checked:hover:bg-blurple-50',
    'checked:focus-visible:hover:bg-blurple-50',
    'checked:focus-visible:border-2',
    'checked:focus-visible:border-blurple-300',
    'checked:after:content-[\'\']',
    'checked:after:absolute',
    'checked:after:top-[45%]',
    'checked:after:left-1/2',
    'checked:after:-translate-x-1/2',
    'checked:after:-translate-y-1/2',
    'checked:after:w-2.5', // Width of the checkmark
    'checked:after:h-1.5', // Height of the checkmark
    'checked:after:border', // Create tick shape
    'checked:after:border-t-0', // Remove top border
    'checked:after:border-r-0', // Remove right border (instead of left)
    'checked:after:border-white', // Checkmark color
    'checked:after:-rotate-45', // Rotate to form an upward tick
    'checked:after:hover:border-blurple-300', // Change color on hover
    'checked:after:focus-visible:border-blurple-300', // Change color on focus
  ]),

  label: cva([
    'flex',
    'items-center',
    'gap-xs',
    'hover:cursor-pointer',
  ], {
    variants: {
      disabled: {
        true: ['cursor-not-allowed', 'has-[span]:text-black/50', 'reading-dark:has-[span]:text-carbon-50/50'],
        false: ['reading-dark:has-[span]:text-carbon-50'],
      },
    },
  }),
}
